export default {"src":"/_next/static/media/stressMotivation.e4ab6ab6.svg","height":586,"width":1048,"blurWidth":0,"blurHeight":0};